import { Mapping } from '@statsbomb/parachute-types';

export const datahubToIqIdMapping = (rawData: Mapping[]) =>
  rawData.reduce<Record<number, number>>((acc, { datahub_id: datahubId, iq_id: iqId }) => {
    acc[datahubId] = iqId;
    return acc;
  }, {});
